import * as T from 'io-ts';
export const CreateEmailUserRequestT = T.type({
    name: T.string,
    email: T.string,
    password: T.string,
    passwordConfirmation: T.string,
});
export const CreateEmailUserErrorResponseT = T.type({
    status: T.literal('Error'),
    error: T.string,
});
export const CreateEmailUserSuccessResponseT = T.type({
    status: T.literal('Ok'),
});
export const CreateEmailUserResponseT = T.union([
    CreateEmailUserSuccessResponseT,
    CreateEmailUserErrorResponseT,
]);
